import { useQuery } from "@tanstack/react-query";
import { request, server } from "./server.ts";
import moment from "moment";
import { IProfile } from "@/models/profile.ts";

interface TProfileParams {
  page?: number;
  limit?: number;
  product_id?: string | null;
  needle?: string;
  filter?: Record<string, any>;
  dateRange?: {
    from: string;
    to: string;
  };
}
export const useGetProfile = (params: TProfileParams = {}) => {
  const {
    page = 1,
    limit = 10,
    needle,
    filter,
    dateRange,
    product_id = "",
  } = params;
  const searchParams = new URLSearchParams();

  searchParams.append("page", page.toString());
  searchParams.append("limit", limit.toString());
  if (needle) searchParams.append("needle", needle);
  if (product_id) searchParams.append("product_id", product_id);
  if (filter) {
    Object.entries(filter).forEach(([key, value]) => {
      searchParams.append(key, value as string);
    });
  }
  if (dateRange?.from) {
    searchParams.append(
      "from",
      moment(dateRange?.from, "DD MMM YYYY").toISOString()
    );
    searchParams.append(
      "to",
      moment(dateRange?.to, "DD MMM YYYY").toISOString()
    );
  }
  return useQuery({
    queryKey: ["profile", product_id, dateRange, filter, needle, limit, page],
    queryFn: async () => {
      try {
        const { data } = await server.get(
          `/hosted_courses/customer_hub?${searchParams}`
        );

        return data as IProfile;
      } catch (err: any) {
        const error_mssg = err?.response?.data;
        const mssg =
          typeof error_mssg === "string"
            ? error_mssg
            : "Oops, an error occurred";
        throw mssg;
      }
    },
  });
};
